import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Tutte le date/ore dell'app in ora italiana (Europe/Rome, ora legale/solare automatica)
["toLocaleString", "toLocaleDateString", "toLocaleTimeString"].forEach((fn) => {
  const orig = Date.prototype[fn];
  Date.prototype[fn] = function (locale, opts) {
    return orig.call(this, locale, { timeZone: "Europe/Rome", ...(opts || {}) });
  };
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
